import { TMemeberAuth } from "src/types/global";

export const SAVED_USER_INFO = ["mbr_id"];

// 회원 권한
export const memberAuthList: { key: TMemeberAuth; label: string }[] = [
  { key: "MA0001", label: "대표자" },
  { key: "MA0002", label: "지사장" },
  { key: "MA0003", label: "부서장" },
  { key: "MA0004", label: "일반회원" }
];

// 회원 상태
export const memberStatus = [
  { key: "0", label: "대기" },
  { key: "1", label: "승인" }
];
